module.exports = __webpack_public_path__ + "static/img/2018.0d840533.png";